// Class: openfl.text._internal.TextFormatRange

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;

// Constructor

var TextFormatRange = function(format,start,end) {
	this.format = format;
	this.start = start;
	this.end = end;
}

// Meta

TextFormatRange.__name__ = "openfl.text._internal.TextFormatRange";
TextFormatRange.__isInterface__ = false;
TextFormatRange.prototype = {
	
};
TextFormatRange.prototype.__class__ = TextFormatRange.prototype.constructor = $hxClasses["openfl.text._internal.TextFormatRange"] = TextFormatRange;

// Init



// Statics




// Export

exports.default = TextFormatRange;